// Styles
import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';

export const Wrap = styled.div`
    margin: ${({ theme }) => `0 -${theme.paddings.inner.mobile.paddingLeft}`};
    & .swiper-container {
      ${({ theme }) => theme.paddings.inner.mobile};
      width: 100%;
      padding-bottom: 30px;
    }
    & .swiper-pagination {
      bottom: 0;
      z-index: 10000;
    }
    & .swiper-pagination-bullet-active {
      background: ${({ theme }) => theme.palette.primary};
    }
    @media only screen and (${Breakpoints.TABLET}) {
        margin: ${({ theme }) => `0 -${theme.paddings.inner.tablet.paddingLeft}`};
        & .swiper-container {
            ${({ theme }) => theme.paddings.inner.tablet};
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        margin: ${({ theme }) => `0 -${theme.paddings.inner.desktop.paddingLeft}`};
        & .swiper-container {
            ${({ theme }) => theme.paddings.inner.desktop};
        }
    }
`;
